var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUserThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#6c7ef2}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__noun_like_576529",
    transform: "translate(-.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2116",
    "data-name": "Group 2116",
    transform: "translate(.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Union_9",
    d: "M41.941 98a12.331 12.331 0 0 1-5.477-1.292l-6.54-3.268A7.68 7.68 0 0 1 22.913 98H7.664A7.671 7.671 0 0 1 0 90.338V44.412a7.673 7.673 0 0 1 7.664-7.662h19.852a9.646 9.646 0 0 0 7.564-3.635 63.8 63.8 0 0 0 11.58-22.42l1.2-4.2A9 9 0 0 1 56.482 0h1.906a8.972 8.972 0 0 1 8.967 8.961v3.55a65.033 65.033 0 0 1-4.673 24.258l23.054-.018A12.273 12.273 0 0 1 98 49.007V59.37a56.318 56.318 0 0 1-7.419 27.917l-3.46 6.052A9.281 9.281 0 0 1 79.083 98zm-2.734-6.771a6.152 6.152 0 0 0 2.734.646h37.142A3.141 3.141 0 0 0 81.8 90.3l3.46-6.052a50.2 50.2 0 0 0 6.61-24.876V49.007a6.14 6.14 0 0 0-6.136-6.132H62.67a6.112 6.112 0 0 1-5.679-8.382 58.877 58.877 0 0 0 4.235-21.982v-3.55a2.84 2.84 0 0 0-2.838-2.836h-1.906a2.848 2.848 0 0 0-2.727 2.055l-1.2 4.2a69.875 69.875 0 0 1-12.69 24.565 15.711 15.711 0 0 1-9.494 5.677 7.654 7.654 0 0 1 .212 1.793v42.503zM6.129 44.412v45.926a1.54 1.54 0 0 0 1.535 1.537h15.249a1.541 1.541 0 0 0 1.539-1.537v-1.393-44.533a1.539 1.539 0 0 0-1.539-1.537H7.664a1.539 1.539 0 0 0-1.535 1.537z",
    className: "prefix__cls-1",
    "data-name": "Union 9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_326",
    cx: 3.36,
    cy: 3.358,
    className: "prefix__cls-1",
    "data-name": "Ellipse 326",
    rx: 3.36,
    ry: 3.358,
    transform: "translate(12.069 79.251)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserThumbsUp);
export default __webpack_public_path__ + "static/media/no_user_thumbs_up.9e539b5fbbe53a97f05bf98454272080.svg";
export { ForwardRef as ReactComponent };